import React, {FunctionComponent} from 'react'
import StylesType from '@/types/StylesType'
import classnames from 'classnames'
import {Row, Col, Radio} from 'antd'
import './style/payMethods.less'
import PayType from '@/types/PayType'
import Icon from '@/components/Icon'

export interface PayMethodsType {
    payType: PayType;
    togglePayType: (type: PayType) => void;
}

type PayMethodsProps = StylesType & PayMethodsType
const PayMethods: FunctionComponent<PayMethodsProps> = props => {
    const {prefixCls = 'gc_', className, payType, togglePayType} = props
    let payList = [{
        value: 1,
        title: '支付宝支付',
        icon: 'iconzhifubao'
    }, {
        value: 9,
        title: '微信支付',
        icon: 'iconweixin'
    }]
    return (
        <Row type='flex' gutter={[12, 0]} align='middle' className={classnames(prefixCls + 'pay_methods', className)}>
            <Col>
                <div className={classnames('titile')}>支付方式</div>
            </Col>
            <Col>
                <Radio.Group
                    value={payType}
                >
                    <Row type='flex' gutter={[20, 0]}>
                        {payList.map(pay => {
                            return (
                                <Col key={pay.value} onClick={() => togglePayType(pay.value as PayType)}>
                                    <Row type='flex' align='middle' className={classnames(prefixCls + 'pay_method',{actived: pay.value === payType})}>
                                        <Col>
                                            <Radio value={pay.value} className={classnames()}/>
                                        </Col>
                                        <Col>
                                            <Icon type={pay.icon} className={classnames(prefixCls+'pay_icon')}></Icon>
                                        </Col>
                                        <Col>
                                            <div>{pay.title}</div>
                                        </Col>
                                    </Row>
                                </Col>
                            )})}
                    </Row>
                </Radio.Group>
            </Col>
        </Row>
    )
}
export default PayMethods
